import { apiClient } from '@/axios'
import type { IApiResponse } from '@/axios/types'
import type { PositionListResponseData } from '@/types/shadow'

// 获取当前账户的岗位信息
export const apiGetPcUserPositionList = (): Promise<IApiResponse<PositionListResponseData>> => {
  // 单独为这个接口设置请求头
  const config = {
    headers: {
      'x-user-agent': 'channel/qiankun platform/qiankun.proretailpc',
      'X-Retail-Global-Area': 'CN',
      'X-Retail-Language': 'zh-CN',
      'X-Retail-Locale': 'CN',
    }
  };
  return apiClient.post<PositionListResponseData>('/mtop/proretailpc/account/getPcUserPositionList', [{}], config);
}
